import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizeGuard } from '../shared/guards/authorize.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'portifolio',
    pathMatch: 'full'
  },
  {
    path: 'usuarios',
    loadChildren: () => import('../components/usuario/usuario.module').then(m => m.UsuarioModule),
  },
  {
    path: 'servicos',
    loadChildren: () => import('../components/servico/servico.module').then(m => m.ServicoModule),
    canActivate: [AuthorizeGuard]
  },
  {
    path: 'areas-negocio',
    loadChildren: () => import('../components/areas-negocio/areas-negocio.module').then(m => m.AreasNegocioModule),
    canActivate: [AuthorizeGuard]
  },
  {
    path: 'portifolio',
    loadChildren: () => import('../components/customer-face/portifolio-servicos/portifolio-servicos.module').then(m => m.PortifolioServicosModule)
  },
  {
    path: 'parametros',
    loadChildren: () => import('../components/parametros/parametros.module').then(m => m.ParametrosModule),
    canActivate: [AuthorizeGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeaturesRoutingModule { }
